import React from "react";
import { Badge } from "antd";
import styles from "./index.less";

export default ({ status, color, text, style }) => (
  <Badge className={styles.inline} status={status} color={color} text={text} style={style} />
);
